(function() {
    // Ensure the drawer is a direct child of <body> to avoid stacking-context issues
    try {
      var _d = document.getElementById('YomiSearchDrawer');
      if (_d && _d.parentNode !== document.body) {
        document.body.appendChild(_d);
      }
    } catch (err) { /* move-to-body failed */ }
    // --- Drawer open/close logic ---
    window.openSearchDrawer = function() {
      var d = document.getElementById('YomiSearchDrawer');
      if(!d) return;
      d.style.display = 'block';
      setTimeout(() => { d.classList.add('active'); var inp = document.getElementById('SearchInputAjax'); if(inp) inp.focus(); }, 10);
      // Ensure the close button uses the immediate-close attribute to avoid third-party interference
      try {
        var _closeBtn = d.querySelector('.search-close-btn');
        if (_closeBtn) {
          try { _closeBtn.setAttribute('onclick', 'window.closeSearchDrawerImmediate()'); } catch(_){}
          try { _closeBtn.style.pointerEvents = 'auto'; } catch(_){}
        }
      } catch(_){}
      document.body.style.overflow = 'hidden';
      // Also deactivate header search overlay/dropdown if present (prevent click-blocking)
      try {
        var hdrOverlay = document.getElementById('yomi-search-overlay');
        if (hdrOverlay) {
          hdrOverlay.classList.remove('active');
          hdrOverlay.style.pointerEvents = 'none';
        }
        var hdrDropdown = document.getElementById('yomi-search-dropdown');
        if (hdrDropdown) hdrDropdown.classList.remove('active');
      } catch (err) { /* header overlay hide failed */ }

      // Aggressive fallback: disable pointer-events on other top-level body children
      try {
        var bodyChildren = Array.prototype.slice.call(document.body.children);
        window._yomiSearchPrevPointer = window._yomiSearchPrevPointer || [];
        window._yomiSearchPrevPointer.length = 0;
        bodyChildren.forEach(function(ch){ if (ch === d) return; window._yomiSearchPrevPointer.push({el: ch, prev: ch.style.pointerEvents || ''}); ch.style.pointerEvents = 'none'; });
      } catch (err) { /* pointer-events fallback failed */ }

      // Add class to body so CSS can hide dynamically-inserted Swym buttons as well
      try { document.body.classList.add('yomi-search-open'); } catch (_) {}

      // Hide Swym wishlist buttons while drawer is open
      try {
        window._yomiHiddenSwym = window._yomiHiddenSwym || [];
        window._yomiHiddenSwym.length = 0;
        var swymBtns = document.querySelectorAll('.swym-wishlist-collections-v2');
        swymBtns.forEach(function(btn){
          if (!btn) return;
          // store previous inline display/visibility
          window._yomiHiddenSwym.push({ el: btn, prevDisplay: btn.style.display || '', prevVisibility: btn.style.visibility || '' });
          try { btn.style.display = 'none'; btn.style.visibility = 'hidden'; } catch(_){}
        });
        // Start a MutationObserver to hide Swym buttons that are inserted dynamically
        try {
          if (!window._yomiSwymObserver) {
            window._yomiSwymObserver = new MutationObserver(function(mutations){
              mutations.forEach(function(m){
                (m.addedNodes || []).forEach(function(n){
                  try {
                    if (!(n instanceof Element)) return;
                    var matches = [];
                    if (n.matches && n.matches('.swym-wishlist-collections-v2')) matches.push(n);
                    var found = (n.querySelectorAll) ? n.querySelectorAll('.swym-wishlist-collections-v2') : [];
                    for (var i=0;i<found.length;i++) matches.push(found[i]);
                    matches.forEach(function(btn){
                      window._yomiHiddenSwym = window._yomiHiddenSwym || [];
                      window._yomiHiddenSwym.push({ el: btn, prevDisplay: btn.style.display || '', prevVisibility: btn.style.visibility || '' });
                      try { btn.style.display = 'none'; btn.style.visibility = 'hidden'; btn.style.pointerEvents = 'none'; } catch(_){ }
                    });
                  } catch(_){}
                });
              });
            });
            window._yomiSwymObserver.observe(document.body, { childList: true, subtree: true });
          }
        } catch(_) {}
      } catch (err) { /* hide swym failed */ }
    };

    window.closeSearchDrawer = function() {
      var d = document.getElementById('YomiSearchDrawer');
      if(!d) return;
      d.classList.remove('active');
      try { document.body.classList.remove('yomi-search-open'); } catch (_) {}
        // Hide after transition completes (content transform or overlay opacity)
        try {
          var contentEl = d.querySelector('.search-drawer-content');
          var overlayEl = d.querySelector('.search-drawer-overlay');
          var finished = false;
          function finishHide(){
            if (finished) return; finished = true;
            try { d.style.display = 'none'; } catch(_){}
            try { document.body.style.overflow = ''; } catch(_){}
            try { if (contentEl) contentEl.removeEventListener('transitionend', onTrans); } catch(_){}
            try { if (overlayEl) overlayEl.removeEventListener('transitionend', onTrans); } catch(_){}
          }
          var timeoutId = setTimeout(function(){ finishHide(); }, 520);
          function onTrans(e){ if (!e || (e.propertyName === 'transform' || e.propertyName === 'opacity')) { clearTimeout(timeoutId); finishHide(); } }
          try { if (contentEl) contentEl.addEventListener('transitionend', onTrans); } catch(_){}
          try { if (overlayEl) overlayEl.addEventListener('transitionend', onTrans); } catch(_){}
        } catch (err) { setTimeout(() => { d.style.display = 'none'; document.body.style.overflow = ''; }, 400); }
      // restore header overlay pointer-events (if any)
      try {
        var hdrOverlay = document.getElementById('yomi-search-overlay');
        if (hdrOverlay) hdrOverlay.style.pointerEvents = '';
      } catch (err) { /* ignore */ }

      // restore pointer-events on body children and remove fallback button
      try {
        if (window._yomiSearchPrevPointer && window._yomiSearchPrevPointer.length) {
          window._yomiSearchPrevPointer.forEach(function(item){ if(item && item.el) item.el.style.pointerEvents = item.prev || ''; });
          window._yomiSearchPrevPointer.length = 0;
        }
        
      } catch (err) { /* restore pointer-events failed */ }

      // Restore Swym wishlist buttons visibility
      try {
        if (window._yomiHiddenSwym && window._yomiHiddenSwym.length) {
          window._yomiHiddenSwym.forEach(function(item){ if(item && item.el){ try { item.el.style.display = item.prevDisplay || ''; item.el.style.visibility = item.prevVisibility || ''; } catch(_){} } });
          window._yomiHiddenSwym.length = 0;
        }
        // Disconnect MutationObserver if any
        try { if (window._yomiSwymObserver) { window._yomiSwymObserver.disconnect(); window._yomiSwymObserver = null; } } catch(_) {}
      } catch (err) { /* restore swym failed */ }
    };

    // Immediate close helper: synchronous cleanup for cases where async/transition handlers are blocked
    window.closeSearchDrawerImmediate = function() {
      try {
        var d = document.getElementById('YomiSearchDrawer');
        if(!d) return;
        d.classList.remove('active');
      } catch(_) {}
      try { document.body.classList.remove('yomi-search-open'); } catch(_) {}
      try { var d2 = document.getElementById('YomiSearchDrawer'); if (d2) d2.style.display = 'none'; } catch(_) {}
      try { document.body.style.overflow = ''; } catch(_) {}
      try {
        if (window._yomiSearchPrevPointer && window._yomiSearchPrevPointer.length) {
          window._yomiSearchPrevPointer.forEach(function(item){ if(item && item.el) item.el.style.pointerEvents = item.prev || ''; });
          window._yomiSearchPrevPointer.length = 0;
        }
      } catch(_) {}
      try {
        if (window._yomiHiddenSwym && window._yomiHiddenSwym.length) {
          window._yomiHiddenSwym.forEach(function(item){ if(item && item.el){ try { item.el.style.display = item.prevDisplay || ''; item.el.style.visibility = item.prevVisibility || ''; } catch(_){} } });
          window._yomiHiddenSwym.length = 0;
        }
      } catch(_) {}
      try { if (window._yomiSwymObserver) { window._yomiSwymObserver.disconnect(); window._yomiSwymObserver = null; } } catch(_) {}
    };

    // --- Robust close logic (click-outside, ESC, swipe) copied from account drawer ---
    var touchStartX = 0;
    var touchStartY = 0;
    var touchStartTime = 0;
    var isSearchDrawerInit = false;

    function initSearchDrawerGestures() {
      if (isSearchDrawerInit) return;
      isSearchDrawerInit = true;
      var drawer = document.getElementById('YomiSearchDrawer');
      if (!drawer) return;

      var overlay = drawer.querySelector('.search-drawer-overlay');
      var content = drawer.querySelector('.search-drawer-content');
        // Ensure overlay taps always close (covering floating elements)
        try {
          if (overlay && !overlay._yomiBound) {
            overlay.addEventListener('click', function(ev){ try { window.closeSearchDrawer(); } catch(_){} }, { capture: true });
            overlay.addEventListener('touchend', function(ev){ try { window.closeSearchDrawer(); } catch(_){} }, { passive: true, capture: true });
            overlay._yomiBound = true;
          }
        } catch(_) {}
      // Click outside content closes (desktop and mobile)
      drawer.addEventListener('click', function(e) {
        try {
          
          var content = drawer.querySelector('.search-drawer-content');
          if (content && !content.contains(e.target)) {
            
            // prevent other handlers from interfering
            if (e.stopImmediatePropagation) e.stopImmediatePropagation();

            // Inline close to avoid external errors blocking closure
            try {
              drawer.classList.remove('active');
              // hide after transition
              setTimeout(function(){
                try { drawer.style.display = 'none'; } catch(_){}
                try { document.body.style.overflow = ''; } catch(_){}
              }, 400);

              // restore pointer-events on body children
              try {
                if (window._yomiSearchPrevPointer && window._yomiSearchPrevPointer.length) {
                  window._yomiSearchPrevPointer.forEach(function(item){ if(item && item.el) item.el.style.pointerEvents = item.prev || ''; });
                  window._yomiSearchPrevPointer.length = 0;
                }
                
              } catch (_) {}

              
            } catch (errClose) {
              
              try { window.closeSearchDrawer(); } catch(_){}
            }
          }
          } catch (err) {
            /* drawer click handler error */
        }
      }, { capture: true });

      // Ensure close button works on mobile/touch and if inline onclick is blocked
      try {
        var closeBtn = drawer.querySelector('.search-close-btn');
        if (closeBtn && !closeBtn._yomiBound) {
          var _closeHandler = function(ev){ try { ev && ev.stopImmediatePropagation && ev.stopImmediatePropagation(); window.closeSearchDrawer(); } catch(_){} };
          closeBtn.addEventListener('click', _closeHandler, { capture: true });
          closeBtn.addEventListener('touchend', _closeHandler, { passive: true, capture: true });
          closeBtn.addEventListener('pointerup', _closeHandler, { capture: true });
          closeBtn._yomiBound = true;
        }
      } catch (err) { /* ignore */ }

      // Ensure the close button always calls the immediate-close fallback
      try {
        var cb = drawer.querySelector('.search-close-btn');
        if (cb) {
          try { cb.setAttribute && cb.setAttribute('onclick', 'window.closeSearchDrawerImmediate && window.closeSearchDrawerImmediate()'); } catch(_){}
          try { cb.style.pointerEvents = 'auto'; cb.style.zIndex = '100005'; } catch(_){}
          if (!cb._yomiBound) {
            var _cbHandler = function(ev){ try { ev && ev.stopImmediatePropagation && ev.stopImmediatePropagation(); window.closeSearchDrawerImmediate && window.closeSearchDrawerImmediate(); } catch(_){} };
            cb.addEventListener('click', _cbHandler, { capture: true });
            cb.addEventListener('pointerup', _cbHandler, { capture: true });
            try { cb.addEventListener && cb.addEventListener('touchend', _cbHandler, { passive: true, capture: true }); } catch(_){}
            cb._yomiBound = true;
          }
        }
      } catch(_) {}

      // Global touch handlers: catch taps outside content and swipes even when click events are suppressed
      try {
        var _globalTouch = { startX: 0, startY: 0, startTime: 0 };
        document.addEventListener('touchstart', function(ev){
          try {
            if (!drawer || !drawer.classList.contains('active')) return;
            if (!ev.touches || !ev.touches[0]) return;
            _globalTouch.startX = ev.touches[0].clientX;
            _globalTouch.startY = ev.touches[0].clientY;
            _globalTouch.startTime = Date.now();
          } catch(_){}
        }, { passive: true, capture: true });

        document.addEventListener('touchend', function(ev){
          try {
            if (!drawer || !drawer.classList.contains('active')) return;
            var touch = (ev.changedTouches && ev.changedTouches[0]) || (ev.touches && ev.touches[0]);
            var elAtPoint = null;
            if (touch) {
              elAtPoint = document.elementFromPoint(touch.clientX, touch.clientY);
            } else {
              elAtPoint = ev.target;
            }
            // If touchend happened outside the content area, close immediately
            if (content && !content.contains(elAtPoint)) {
              try { window.closeSearchDrawer(); } catch(_){ }
              return;
            }

            // Otherwise treat as potential swipe on content
            if (!ev.changedTouches || !ev.changedTouches[0]) return;
            var endX = ev.changedTouches[0].clientX;
            var endY = ev.changedTouches[0].clientY;
            var deltaX = endX - (_globalTouch.startX || 0);
            var deltaY = Math.abs(endY - (_globalTouch.startY || 0));
            var elapsed = Date.now() - (_globalTouch.startTime || 0);
            if (deltaX > 50 && deltaX > deltaY * 2 && elapsed < 600) {
              try { window.closeSearchDrawer(); } catch(_){ }
            }
          } catch(_){ }
        }, { passive: true, capture: true });
      } catch (err) { /* touch fallback failed */ }

      // Pointerup fallback: detect pointer releases outside the drawer content and force-close
      try {
        document.addEventListener('pointerup', function(ev){
          try {
            var d = document.getElementById('YomiSearchDrawer');
            if (!d || !d.classList.contains('active')) return;
            var x = ev.clientX, y = ev.clientY;
            if (typeof x === 'number' && typeof y === 'number') {
              var el = document.elementFromPoint(x, y);
              if (content && !content.contains(el)) {
                try { window.closeSearchDrawerImmediate && window.closeSearchDrawerImmediate(); } catch(_){}
              }
            }
          } catch(_) {}
        }, { capture: true });
      } catch(_) {}

      // ensure close button click is logged
        try {
          // intentionally left blank: no debug close button listener
        } catch (err) { /* ignore */ }

      // ESC closes
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' || e.keyCode === 27) {
          
          var d = document.getElementById('YomiSearchDrawer');
          if (d && d.classList.contains('active')) {
            window.closeSearchDrawer();
          }
        }
      }, { capture: true });

      // Swipe gesture for mobile
      if (content) {
        content.addEventListener('touchstart', function(e) {
          var d = document.getElementById('YomiSearchDrawer');
          if (!d || !d.classList.contains('active')) return;

          var tag = e.target.tagName.toLowerCase();
          if (tag === 'input' || tag === 'button' || tag === 'a' || tag === 'textarea' || tag === 'select') return;

          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
          touchStartTime = Date.now();
        }, { passive: true });

        content.addEventListener('touchend', function(e) {
          var d = document.getElementById('YomiSearchDrawer');
          if (!d || !d.classList.contains('active')) return;
          if (touchStartX === 0) return;

          var endX = e.changedTouches[0].clientX;
          var endY = e.changedTouches[0].clientY;
          var deltaX = endX - touchStartX;
          var deltaY = Math.abs(endY - touchStartY);
          var elapsed = Date.now() - touchStartTime;

          // Swipe right to close
          if (deltaX > 50 && deltaX > deltaY * 2 && elapsed < 600) {
            window.closeSearchDrawer();
          }

          touchStartX = 0;
          touchStartY = 0;
        }, { passive: true });
      }
    }

    // Initialize when DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSearchDrawerGestures);
    } else {
      initSearchDrawerGestures();
    }

    // Extra ensure-bind call in case script runs before the drawer is moved to body
    function ensureCloseBoundNow(){
      try {
        var cb = document.querySelector('#YomiSearchDrawer .search-close-btn');
        if(cb){
          try{ cb.setAttribute && cb.setAttribute('onclick','window.closeSearchDrawerImmediate && window.closeSearchDrawerImmediate()'); }catch(_){ }
          try{ cb.style.pointerEvents='auto'; cb.style.zIndex='100005'; }catch(_){ }
          if(!cb._yomiBound){
            cb.addEventListener('click', function(ev){ ev && ev.stopImmediatePropagation && ev.stopImmediatePropagation(); window.closeSearchDrawerImmediate && window.closeSearchDrawerImmediate(); }, {capture:true});
            try{ cb.addEventListener('touchend', function(ev){ window.closeSearchDrawerImmediate && window.closeSearchDrawerImmediate(); }, {passive:true,capture:true}); }catch(_){ }
            cb.addEventListener('pointerup', function(ev){ window.closeSearchDrawerImmediate && window.closeSearchDrawerImmediate(); }, {capture:true});
            cb._yomiBound = true;
          }
        }
      } catch(_) {}
    }
    setTimeout(ensureCloseBoundNow, 50);

    // --- Predictive search logic ---
    const input = document.getElementById('SearchInputAjax');
    const results = document.getElementById('PredictiveSearchResults');
    const moreBtn = document.getElementById('SearchMoreBtnWrapper');
    const _yomiSearchCfgEl = document.getElementById('YomiSearchDrawer');
    const showArticles = !!(_yomiSearchCfgEl && _yomiSearchCfgEl.dataset.showArticles === 'true');

    // Helper: parse a price string and format using Intl.NumberFormat
    function parseAndFormatPrice(priceStr) {
      if (priceStr === null || typeof priceStr === 'undefined') return priceStr;
      try {
        var orig = String(priceStr).trim();
        var symbolMatch = orig.match(/[€£¥$₹₩₪₱฿₫]/);
        var symbol = symbolMatch ? symbolMatch[0] : '';
        var currencyMap = {'€':'EUR','$':'USD','£':'GBP','¥':'JPY','₹':'INR','₩':'KRW','₪':'ILS','₱':'PHP','฿':'THB','₫':'VND'};
        var currency = currencyMap[symbol] || (window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : (window.Shopify && Shopify.shop && Shopify.shop.currency ? Shopify.shop.currency : 'USD'));

        // Keep only digits, dots and commas and minus
        var s = orig.replace(/[^0-9,\.\-]/g,'');
        if (!s) return orig;

        var lastDot = s.lastIndexOf('.');
        var lastComma = s.lastIndexOf(',');
        if (lastDot > -1 && lastComma > -1) {
          // both present: assume the rightmost separator is the decimal separator
          var decSep = (lastDot > lastComma) ? '.' : ',';
          var intPart = s.slice(0, s.lastIndexOf(decSep)).replace(/[.,]/g,'');
          var fracPart = s.slice(s.lastIndexOf(decSep) + 1);
          s = intPart + '.' + fracPart;
        } else if (lastComma > -1) {
          // only comma present: determine if it's decimal by length of trailing digits
          var parts = s.split(',');
          if (parts[1] && parts[1].length <= 2) {
            s = parts[0].replace(/[.,]/g,'') + '.' + parts[1];
          } else {
            s = s.replace(/,/g,'');
          }
        } else {
          // only dot or nothing: remove thousands separators
          s = s.replace(/,/g,'');
        }

        var n = parseFloat(s);
        if (isNaN(n)) return orig;
        // Normalize to two decimals
        n = Math.round(n * 100) / 100;
        var locale = (typeof navigator !== 'undefined' && navigator.language) ? navigator.language : 'en-US';
        return new Intl.NumberFormat(locale, { style: 'currency', currency: currency, minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n);
      } catch (e) { return priceStr; }
    }

    input.addEventListener('input', function() {
      const query = this.value.trim();
      if (query.length < 2) { results.innerHTML = ''; if(moreBtn) moreBtn.style.display = 'none'; return; }

      clearTimeout(window.yomiSearchTimer);
      window.yomiSearchTimer = setTimeout(() => {
        let url = `/search?view=predictive&q=${encodeURIComponent(query)}`;
        if(!showArticles) url += '&type=product';
        
        fetch(url)
        .then(r => r.json())
        .then(items => {
          results.innerHTML = '';
          if (items.length > 0) {
            items.forEach(p => {
              var formattedPrice = p.price ? parseAndFormatPrice(p.price) : '';
              if(!showArticles && p.type === 'article') return;
              
              results.innerHTML += `
                <a href="${p.url}" class="predictive-item">
                  <img src="${p.image}" alt="${p.title}">
                  <div class="predictive-item-info">
                    <div class="predictive-item-header">
                      <span class="predictive-item-title">${p.title}</span>
                      ${formattedPrice ? `<span class="predictive-item-price">${formattedPrice}</span>` : ''}
                    </div>
                    <div class="predictive-item-meta">${p.meta}</div>
                  </div>
                </a>`;
            });
            if(moreBtn) {
              moreBtn.style.display = 'block';
              document.getElementById('ViewMoreSearch').href = `/search?q=${encodeURIComponent(query)}`;
            }
          } else {
            results.innerHTML = '<p class="search-no-results">' + ((_yomiSearchCfgEl && _yomiSearchCfgEl.dataset.noResultsText) || '') + '</p>';
            if(moreBtn) moreBtn.style.display = 'none';
          }
        });
      }, 300);
    });

    // overlay click handled by drawer click listener above
  })();
